const checkIsMobile = () => {
  const { userAgent } = navigator;

  if (userAgent.match(/Android/i) || userAgent.match(/iPhone|iPad|iPod/i)) {
    return true;
  }

  if (userAgent.match(/Windows/i) || userAgent.match(/Macintosh/i)) {
    return false;
  }

  return true;
};

export default checkIsMobile;
